export default class PageCover{
	constructor(){
		const pagecover = document.querySelectorAll(".pagecover");
		pagecover.forEach(cover=>{ this.initPagecover(cover); });
	}
	initPagecover(cover){
		const pagecoverBg = cover.querySelector(".pagecover__bg");
		const pagecoverImage = cover.querySelector(".pagecover__bg__img");
		if(window.currentContext == "pc"){
			gsap.fromTo(pagecoverImage, {
				yPercent: -20,
			},{ 
				yPercent: 20,
				ease: "none",
				scrollTrigger: { 
					trigger: pagecoverBg,
					start: "top bottom",
					end: "bottom top",
					scrub: true,
					invalidateOnRefresh: true
				}
			});
		}else{
			gsap.fromTo(pagecoverImage, {
				yPercent: 0,
			},{ 
				yPercent: 20,
				ease: "none",
				scrollTrigger: { 
					trigger: cover,
					start: "bottom bottom",
					end: "bottom top",
					scrub: true,
					invalidateOnRefresh: true
				}
			});
		}
	}
}